import { render } from "./squareRating.vue?vue&type=template&id=12e7b7c5"
import script from "./squareRating.vue?vue&type=script&lang=js"
export * from "./squareRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__